export default __webpack_public_path__ + "static/media/goopter-ecommerce-multiple-payments.f60c653e.jpg";